import Image from 'next/image';

import { Flex } from '@/components/Flex';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { MoneyFragment } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';
import { CembraMessage } from '@/messages/common';
import { useConfigProvider } from '@/providers/ConfigProvider';
import { useRegionProvider } from '@/providers/RegionProvider';

import CreditPlusIcon from '@/assets/icons/credit-plus.svg';

import * as S from '../ProductDetail.styles';

interface CreditPlusSentenceProps {
  onLearnMore: () => void;
  price: Maybe<MoneyFragment>;
  variantCTA?: OrderAppCtaType;
}

export const CreditPlusSentence = ({
  onLearnMore,
  price,
  variantCTA,
}: CreditPlusSentenceProps) => {
  const { formatPrice } = useRegionProvider();

  const { creditPlusPaymentMax, creditPlusPaymentMin } = useConfigProvider();

  if (!price || variantCTA !== 'ORDER') return null;

  if (
    price.amount < creditPlusPaymentMin ||
    price.amount > creditPlusPaymentMax
  )
    return null;

  return (
    <Flex flexDirection='column' marginBottom='s100' onClick={onLearnMore}>
      <Flex alignItems='center'>
        <S.LearnMore data-testid='cembrabLearnMore' scale='p2'>
          {CembraMessage(
            formatPrice({
              amount: Math.ceil((price.amount / 48) * 100) / 100,
              currency: price.currency,
            }),
          )}
        </S.LearnMore>
        &nbsp;
        <Image alt='cembra' height={16} src={CreditPlusIcon} width={88} />
      </Flex>
    </Flex>
  );
};
